import Donut from 'assets/images/donut.min.svg?url';
import { AntRow } from 'components/ant/AntRow';
import React from 'react';

import { ModalSubtitle, ModalTitle } from './Shared.styled';

export const Maintenance = (
  <div>
    <AntRow justify="center">
      <img src={Donut} alt="" />
    </AntRow>
    <ModalTitle justify="center">We are updating system now, please wait a few minutes...</ModalTitle>
    <ModalSubtitle justify="center">To save recent activity don’t close this window. </ModalSubtitle>
  </div>
);
